export default __webpack_public_path__ + "static/media/BarlowSemiCondensed-Regular.05cbb3ba.ttf";